// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sequence-summary {
    width: 100%;
    box-sizing: border-box;
}


/* =========================================
   Onglets
   ========================================= */

.sequence-summary-tabs {
    display: flex;
    align-items: center;
    height: 20px;
    gap: 4px;
}


.sequence-summary-tab {
    display: flex;
    align-items: center;
    height: 28px;
    padding: 0 8px;
    box-sizing: border-box;

    color: #cfcfcf;

    cursor: pointer;

    border: 1px solid transparent;
    border-radius: 3px;

    font-size: 12px;
}


.sequence-summary-tab:hover {
    background: rgba(146, 146, 255, 0.08);
}


.sequence-summary-tab.active {
    border: 1px solid #9292ff;
    background: #252525;
    color: #eeeeee;
}


/* Image devant le titre */

.sequence-summary-tab-image {
    width: 16px;
    height: 16px;

    object-fit: contain;

    margin-right: 6px;
}


/* =========================================
   Zone de texte
   ========================================= */

.sequence-summary-editor {
    position: relative;

    width: 100%;
}


.sequence-summary-editor textarea {
    display: block;
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    resize: none;
    background: #202020;
    color: #eeeeee;

    border: 1px solid #808080;

    padding: 8px;

    font-family: inherit;
    font-size: 12px;
    outline: none;
}


.sequence-summary-editor textarea:focus {
    border-color: #9292ff;
}


/* =========================================
   Compteur
   ========================================= */

.sequence-summary-counter {
    position: absolute;
    right: 8px;
    bottom: 6px;
    padding: 2px 5px;
    background: rgba(0, 0, 0, 0.65);

    color: #bbbbbb;

    font-size: 9px;

    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/sequencesummary.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,QAAQ;AACZ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,sBAAsB;;IAEtB,cAAc;;IAEd,eAAe;;IAEf,6BAA6B;IAC7B,kBAAkB;;IAElB,eAAe;AACnB;;;AAGA;IACI,qCAAqC;AACzC;;;AAGA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;;AAGA,0BAA0B;;AAE1B;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;;IAEnB,iBAAiB;AACrB;;;AAGA;;8CAE8C;;AAE9C;IACI,kBAAkB;;IAElB,WAAW;AACf;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,cAAc;;IAEd,yBAAyB;;IAEzB,YAAY;;IAEZ,oBAAoB;IACpB,eAAe;IACf,aAAa;AACjB;;;AAGA;IACI,qBAAqB;AACzB;;;AAGA;;8CAE8C;;AAE9C;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,+BAA+B;;IAE/B,cAAc;;IAEd,cAAc;;IAEd,oBAAoB;AACxB","sourcesContent":[".sequence-summary {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n\n/* =========================================\n   Onglets\n   ========================================= */\n\n.sequence-summary-tabs {\n    display: flex;\n    align-items: center;\n    height: 20px;\n    gap: 4px;\n}\n\n\n.sequence-summary-tab {\n    display: flex;\n    align-items: center;\n    height: 28px;\n    padding: 0 8px;\n    box-sizing: border-box;\n\n    color: #cfcfcf;\n\n    cursor: pointer;\n\n    border: 1px solid transparent;\n    border-radius: 3px;\n\n    font-size: 12px;\n}\n\n\n.sequence-summary-tab:hover {\n    background: rgba(146, 146, 255, 0.08);\n}\n\n\n.sequence-summary-tab.active {\n    border: 1px solid #9292ff;\n    background: #252525;\n    color: #eeeeee;\n}\n\n\n/* Image devant le titre */\n\n.sequence-summary-tab-image {\n    width: 16px;\n    height: 16px;\n\n    object-fit: contain;\n\n    margin-right: 6px;\n}\n\n\n/* =========================================\n   Zone de texte\n   ========================================= */\n\n.sequence-summary-editor {\n    position: relative;\n\n    width: 100%;\n}\n\n\n.sequence-summary-editor textarea {\n    display: block;\n    width: 100%;\n    height: 80px;\n    box-sizing: border-box;\n    resize: none;\n    background: #202020;\n    color: #eeeeee;\n\n    border: 1px solid #808080;\n\n    padding: 8px;\n\n    font-family: inherit;\n    font-size: 12px;\n    outline: none;\n}\n\n\n.sequence-summary-editor textarea:focus {\n    border-color: #9292ff;\n}\n\n\n/* =========================================\n   Compteur\n   ========================================= */\n\n.sequence-summary-counter {\n    position: absolute;\n    right: 8px;\n    bottom: 6px;\n    padding: 2px 5px;\n    background: rgba(0, 0, 0, 0.65);\n\n    color: #bbbbbb;\n\n    font-size: 9px;\n\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
